import { ActionAccessibility } from "../avyna/action-accessibility.model";

export class IntuneUser {
  id?: string;
  deletedDateTime?: string | null;
  accountEnabled?: boolean | null;
  ageGroup?: string | null;
  businessPhones?: string[];
  city?: string | null;
  createdDateTime?: string | null;
  creationType?: string | null;
  companyName?: string | null;
  consentProvidedForMinor?: string | null;
  country?: string | null;
  department?: string | null;
  displayName?: string | null;
  employeeId?: string | null;
  employeeHireDate?: string | null;
  employeeLeaveDateTime?: string | null;
  employeeType?: string | null;
  faxNumber?: string | null;
  givenName?: string | null;
  imAddresses?: string[];
  infoCatalogs?: string[];
  isLicenseReconciliationNeeded?: boolean | null;
  isManagementRestricted?: boolean | null;
  isResourceAccount?: boolean | null;
  jobTitle?: string | null;
  legalAgeGroupClassification?: string | null;
  mail?: string | null;
  mailNickname?: string | null;
  mobilePhone?: string | null;
  onPremisesDistinguishedName?: string | null;
  officeLocation?: string | null;
  onPremisesDomainName?: string | null;
  onPremisesImmutableId?: string | null;
  onPremisesLastSyncDateTime?: string | null;
  onPremisesObjectIdentifier?: string | null;
  onPremisesSecurityIdentifier?: string | null;
  onPremisesSamAccountName?: string | null;
  onPremisesSyncEnabled?: boolean | null;
  onPremisesUserPrincipalName?: string | null;
  otherMails?: string[];
  passwordPolicies?: string | null;
  postalCode?: string | null;
  preferredDataLocation?: string | null;
  preferred_lang?: string | null;
  proxyAddresses?: string[];
  refreshTokensValidFromDateTime?: string | null;
  securityIdentifier?: string | null;
  showInAddressList?: boolean | null;
  signInSessionsValidFromDateTime?: string | null;
  state?: string | null;
  streetAddress?: string | null;
  surname?: string | null;
  usageLocation?: string | null;
  userPrincipalName?: string | null;
  externalUserConvertedOn?: string | null;
  externalUserState?: string | null;
  externalUserStateChangeDateTime?: string | null;
  userType?: string | null;
  identityParentId?: string | null;
  agentIdentityBlueprintId?: string | null;
  employeeOrgData?: any | null;
  passwordProfile?: any | null;
  assignedLicenses?: AssignedLicense[];
  assignedPlans?: AssignedPlan[];
  authorizationInfo?: AuthorizationInfo;
  cloudRealtimeCommunicationInfo?: CloudRealtimeCommunicationInfo;
  deviceKeys?: DeviceKey[];
  identities?: Identity[];
  onPremisesExtensionAttributes?: OnPremisesExtensionAttributes;
  onPremisesProvisioningErrors?: any[];
  onPremisesSipInfo?: OnPremisesSipInfo;
  provisionedPlans?: ProvisionedPlan[];
  serviceProvisioningErrors?: any[];
  manager?: IntuneUser;
  appRoleAssignments?: AppRoleAssignment[];
  memberOf?: DirectoryObject[];
  transitiveMemberOf?: DirectoryObject[];
  directReports?: IntuneUser[];
  ownedObjects?: DirectoryObject[];
  sponsors?: any[];
  actions_accessibility?: ActionAccessibility[] | null;

  constructor(data?: Partial<IntuneUser>) {
    Object.assign(this, data);
  }

  displayUserName(fallback: string = 'shared.general.labels.na'): string {
    return this.displayName || fallback;
  }

  displayEmail(fallback: string = 'shared.general.labels.na'): string {
    return this.userPrincipalName || this.mail || fallback;
  }

  displayJobTitle(fallback: string = 'shared.general.labels.na'): string {
    return this.jobTitle || fallback;
  }

  displayDepartment(fallback: string = 'shared.general.labels.na'): string {
    return this.department || fallback;
  }

  displayPhone(fallback: string = 'shared.general.labels.na'): string {
    return this.businessPhones?.[0] || fallback;
  }

  displayMobilePhone(fallback: string = 'shared.general.labels.na'): string {
    return this.mobilePhone || fallback;
  }

  displayEmployeeId(fallback: string = 'shared.general.labels.na'): string {
    return this.employeeId || fallback;
  }

  routeId(): string {
    return this.id || '';
  }
}

export class AssignedLicense {
  disabledPlans?: string[];
  skuId?: string;

  constructor(data?: Partial<AssignedLicense>) {
    Object.assign(this, data);
  }
}

export class AssignedPlan {
  assignedDateTime?: string;
  capabilityStatus?: string;
  service?: string;
  servicePlanId?: string;

  constructor(data?: Partial<AssignedPlan>) {
    Object.assign(this, data);
  }
}

export class AuthorizationInfo {
  certificateUserIds?: string[];

  constructor(data?: Partial<AuthorizationInfo>) {
    Object.assign(this, data);
  }
}

export class CloudRealtimeCommunicationInfo {
  isSipEnabled?: boolean | null;

  constructor(data?: Partial<CloudRealtimeCommunicationInfo>) {
    Object.assign(this, data);
  }
}

export class DeviceKey {
  deviceId?: string;
  keyMaterial?: string;
  keyType?: string;

  constructor(data?: Partial<DeviceKey>) {
    Object.assign(this, data);
  }
}

export class Identity {
  signInType?: string;
  issuer?: string;
  issuerAssignedId?: string;

  constructor(data?: Partial<Identity>) {
    Object.assign(this, data);
  }
}

export class OnPremisesExtensionAttributes {
  extensionAttribute1?: string | null;
  extensionAttribute2?: string | null;
  extensionAttribute3?: string | null;
  extensionAttribute4?: string | null;
  extensionAttribute5?: string | null;
  extensionAttribute6?: string | null;
  extensionAttribute7?: string | null;
  extensionAttribute8?: string | null;
  extensionAttribute9?: string | null;
  extensionAttribute10?: string | null;
  extensionAttribute11?: string | null;
  extensionAttribute12?: string | null;
  extensionAttribute13?: string | null;
  extensionAttribute14?: string | null;
  extensionAttribute15?: string | null;

  constructor(data?: Partial<OnPremisesExtensionAttributes>) {
    Object.assign(this, data);
  }
}

export class OnPremisesSipInfo {
  isSipEnabled?: boolean;
  sipDeploymentLocation?: string | null;
  sipPrimaryAddress?: string | null;

  constructor(data?: Partial<OnPremisesSipInfo>) {
    Object.assign(this, data);
  }
}

export class ProvisionedPlan {
  capabilityStatus?: string;
  provisioningStatus?: string;
  service?: string;

  constructor(data?: Partial<ProvisionedPlan>) {
    Object.assign(this, data);
  }
}

export class AppRoleAssignment {
  id?: string;
  deletedDateTime?: string | null;
  creationTimestamp?: string;
  appRoleId?: string;
  principalDisplayName?: string;
  principalId?: string;
  principalType?: string;
  resourceDisplayName?: string;
  resourceId?: string;

  constructor(data?: Partial<AppRoleAssignment>) {
    Object.assign(this, data);
  }
}

export class DirectoryObject {
  '@odata.type'?: string;
  id?: string;
  deletedDateTime?: string | null;
  description?: string | null;
  displayName?: string | null;

  classification?: string | null;
  createdDateTime?: string | null;
  createdByAppId?: string | null;
  organizationId?: string | null;
  expirationDateTime?: string | null;
  groupTypes?: string[];
  infoCatalogs?: string[];
  isAssignableToRole?: boolean | null;
  isManagementRestricted?: boolean | null;
  mail?: string | null;
  mailEnabled?: boolean | null;
  mailNickname?: string | null;
  membershipRule?: string | null;
  membershipRuleProcessingState?: string | null;
  onPremisesDomainName?: string | null;
  onPremisesLastSyncDateTime?: string | null;
  onPremisesNetBiosName?: string | null;
  onPremisesObjectIdentifier?: string | null;
  onPremisesSamAccountName?: string | null;
  onPremisesSecurityIdentifier?: string | null;
  onPremisesSyncEnabled?: boolean | null;
  preferredDataLocation?: string | null;
  preferred_lang?: string | null;
  proxyAddresses?: string[];
  renewedDateTime?: string | null;
  resourceBehaviorOptions?: string[];
  resourceProvisioningOptions?: string[];
  securityEnabled?: boolean | null;
  securityIdentifier?: string | null;
  theme?: string | null;
  visibility?: string | null;
  uniqueName?: string | null;
  writebackConfiguration?: WritebackConfiguration;

  roleTemplateId?: string | null;

  constructor(data?: Partial<DirectoryObject>) {
    Object.assign(this, data);
  }
}

export class WritebackConfiguration {
  isEnabled?: boolean | null;
  onPremisesGroupType?: string | null;

  constructor(data?: Partial<WritebackConfiguration>) {
    Object.assign(this, data);
  }
}

export class LicenseDetails {
  id?: string;
  skuId?: string;
  skuPartNumber?: string;
  servicePlans?: ServicePlan[];
  displayName?: string;

  constructor(data?: Partial<LicenseDetails>) {
    Object.assign(this, data);
  }
}

export class ServicePlan {
  servicePlanId?: string;
  servicePlanName?: string;
  servicePlanType?: string;
  provisioningStatus?: string;
  appliesTo?: string;
  displayName?: string;

  constructor(data?: Partial<ServicePlan>) {
    Object.assign(this, data);
  }
}

export class AlternativeSecurityId {
  type?: number;
  identityProvider?: string | null;
  key?: string;

  constructor(data?: Partial<AlternativeSecurityId>) {
    Object.assign(this, data);
  }
}
